<template>
    <header>
        <div class="header__logo">
            <a href="https://www.pixnet.net/" class="pixnet">
                <img src="@/assets/images/logo__pixnet.svg" alt="痞客邦" loading="lazy" />
            </a>
            <span class="line"></span>
            <a href="https://www.paulaschoice.com.tw/index.php" class="paulaschoice">
                <img src="@/assets/images/logo__paulaschoice.svg" alt="2023 寶拉珍選" loading="lazy" />
                <h1>2023 寶拉珍選</h1>
            </a>
        </div>
        <svg class="ham hamRotate" viewBox="0 0 100 100" width="40" :class="{ 'active': menuState }"
            @click="menuState = !menuState; gtagEvent('', '功能按鈕', 'Menu點擊')">
            <path class="line top"
                d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20" />
            <path class="line middle" d="m 30,50 h 40" />
            <path class="line bottom"
                d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20" />
        </svg>
        <Transition>
            <ul v-if="menuState" class="header__nav">
                <li v-for="nav in navList" :key="nav.title" @click="scrolltoBlock(nav.section)">
                    {{ nav.title }}
                </li>
            </ul>
        </Transition>
    </header>
</template>

<script setup>
import { ref, watch } from 'vue';
import navList from '@/assets/data/navList.json';
import gtagEvent from '@/assets/js/gtag';
/** 漢堡menu開關 */
const menuState = ref(false);
/** 點擊滑動至指定區域
 * @param {string} path 路徑
 * @param {string} block 區塊名字
 */
const scrolltoBlock = async (block) => {
    if (block !== 'highlights') {
        menuState.value = false;
    }
    const goToBlock = document.querySelector(`.${block}`);
    let offsetTopPosition = 20;

    window.scroll({
        top: goToBlock.offsetTop - offsetTopPosition,
        behavior: 'smooth',
    });
};

watch(menuState, (newValue) => {
    if (newValue) window.addEventListener('scroll', () => (menuState.value = false));
});
</script>

<style lang="scss" scoped>
@import '@/styles/theHeader';
</style>
